import { render, staticRenderFns } from "./OnboardAvailabilityForm.vue?vue&type=template&id=48a70f4a&scoped=true&"
import script from "./OnboardAvailabilityForm.vue?vue&type=script&lang=ts&"
export * from "./OnboardAvailabilityForm.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardAvailabilityForm.vue?vue&type=style&index=0&id=48a70f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a70f4a",
  null
  
)

export default component.exports